import { useState, useEffect } from 'react';
import { breakpoints } from 'styles';

export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: globalThis.innerWidth,
    height: globalThis.innerHeight,
    isMobile: globalThis.innerWidth <= breakpoints.s,
    isTablet: globalThis.innerWidth <= breakpoints.l,
    isDesktop: globalThis.innerWidth >= breakpoints.l
  });

  // Update on screen resize
  useEffect(() => {
    function handleResize() {
      setScreenSize({
        width: globalThis.innerWidth,
        height: globalThis.innerHeight,
        isMobile: globalThis.innerWidth <= breakpoints.s,
        isTablet: globalThis.innerWidth <= breakpoints.l,
        isDesktop: globalThis.innerWidth >= breakpoints.l
      });
    }

    globalThis.addEventListener('resize', handleResize);

    // Clean up event listener on unmount
    return () => {
      globalThis.removeEventListener('resize', handleResize);
    };
  }, []);

  return screenSize;
};
